// Small reusable titled-card wrapper, adapted from invoice-loader-react's
// dashboard Panel component to this app's existing design tokens (ink/brand).
export default function Panel({ title, icon, action, children }) {
  return (
    <section className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
      <div className="mb-4 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          {icon && <span className="text-brand-600">{icon}</span>}
          <h2 className="text-sm font-semibold uppercase tracking-wide text-gray-700">{title}</h2>
        </div>
        {action}
      </div>
      {children}
    </section>
  );
}
